import {BitMapMultiplier} from "./BitmapMultiplier";
import {GameAssets} from "../GameAssets";

export class DeadMultiplier extends PIXI.Container {
    private _enable: boolean = true;
    private _multiplier: BitMapMultiplier;

    constructor(value: number) {
        super();
        this.init(value);
    }

    init(value: number): void {
        this._multiplier = new BitMapMultiplier(GameAssets.BITMAP_FONT_X_MULTIPLIER_WIN_COUNT_UP, 10, "x");
        this._multiplier.anchor = new PIXI.Point(1, 0);
        this._multiplier.name = "multiplier";
        this._multiplier.value = value;
        this.addChild( this._multiplier);
        this.enable = true;
        this.name = "DeadMultiplier";
    }

    get value(): number {
        return this._multiplier.value;
    }

    set enable(value: boolean) {
        this._enable = value;
        (this.children[0] as BitMapMultiplier).tint = value ? 0xffffff : 0x777676;
    }
}